import moment from 'moment';
import { TestResults } from '../domains/results';
type SpreadsheetSheetRowCell = kendo.ui.SpreadsheetSheetRowCell;
type SpreadsheetSheet = kendo.ui.SpreadsheetSheet;

export const convertTestResultsToSheets = (
  tests: TestResults[],
): SpreadsheetSheet[] => {
  if (tests.length) {
    let summarySheet: SpreadsheetSheet = {
      name: `${tests[0].mlTestName} (summary)`,
      rows: [],
    };
    const longestSummary = tests.reduce(
      (longestTest, t) =>
        (t.summary?.properties?.length || 0) >
        (longestTest.summary?.properties?.length || 0)
          ? t
          : longestTest,
      tests[0],
    );
    const listSummaryColumns = longestSummary.summary?.properties.map((p) => {
      const cell: SpreadsheetSheetRowCell = {
        value: p.name,
      };
      return cell;
    });
    summarySheet.rows?.push({
      cells: listSummaryColumns,
    });

    let analysisSheet: SpreadsheetSheet = {
      name: `${tests[0].mlTestName} (analysis)`,
      rows: [],
    };
    const longestAnalysis = tests.reduce(
        (longestTest, t) =>
            (t.analysis?.properties?.length || 0) >
            (longestTest.analysis?.properties?.length || 0)
                ? t
                : longestTest,
        tests[0],
    );
    const listAnalysisColumns = longestAnalysis.analysis?.properties.map((p) => {
      const cell: SpreadsheetSheetRowCell = {
        value: p.name,
      };
      return cell;
    });
    analysisSheet.rows?.push({
      cells: listAnalysisColumns,
    });

    tests.forEach((test, testIndex) => {

      let cells: SpreadsheetSheetRowCell[] = [];
          // add row according each value
      longestSummary.summary?.properties.forEach((summaryP) => {
        const valuesByPropertySummary = test.summary?.properties.find(
            (p) => p.name === summaryP.name,
        );
        cells.push({
          value: valuesByPropertySummary?.values[0],
        });
      });
      summarySheet.rows?.push({cells});


      if (testIndex !== 0) {
        analysisSheet.rows = analysisSheet.rows?.concat(Array(3).fill({}));
      }
      analysisSheet.rows?.push({
        cells: [
          {
            value: test.personName,
          },
          {
            value: moment(test.date).format('DD MMM YYYY-HH:mm:ss'),
          },
        ],
      });
      if (testIndex !== 0) {
        analysisSheet.rows = analysisSheet.rows?.concat(Array(3).fill({}));
      }


      // add row according each value
      longestAnalysis.analysis?.properties[0]?.values.forEach((_: any, propIndex: number) => {
        cells = [];
        longestAnalysis.analysis?.properties.forEach((analysisP) => {
          const valuesByPropertyAnalysis = test.analysis?.properties.find(
              (p) => p.name === analysisP.name,
          );
          cells.push({
            value: valuesByPropertyAnalysis?.values[propIndex],
          });
        });
        analysisSheet.rows?.push({cells});
      });
    });

    return [summarySheet, analysisSheet];
  }

  return [];
};
